import {createAction} from '@reduxjs/toolkit';
import {FilterValue} from 'src/hooks/filtered-data/useFilteredData';
import {Filters} from 'src/modules/change-requests/typedefs';

export const SET_CHANGE_REQUEST_FILTER = 'SET_CHANGE_REQUEST_FILTER';
export const CLEAR_CHANGE_REQUEST_FILTERS = 'CLEAR_CHANGE_REQUEST_FILTERS';
export const SET_ALL_CHANGE_REQUEST_FILTERS = 'SET_ALL_CHANGE_REQUEST_FILTERS';

export const setAllChangeRequestsFilters = createAction<Filters>(SET_ALL_CHANGE_REQUEST_FILTERS);

export const setChangeRequestsFilter = createAction<{
    filterType: string,
    filterValue: FilterValue,
}>(SET_CHANGE_REQUEST_FILTER);

export const clearChangeRequestsFilters = createAction(CLEAR_CHANGE_REQUEST_FILTERS);
